import {
  HOLIDAY_END_DATE,
  HOLIDAY_START_DATE
} from 'containers/HolidayDelays/constants/index.js'
import {
  isAfterDateUtil,
  isBeforeDateUtil
} from 'packages/src'

export default function isHolidayDateUtil () {
  const currentDate = new Date()
  return (
    isAfterDateUtil(currentDate, HOLIDAY_START_DATE) &&
    isBeforeDateUtil(currentDate, HOLIDAY_END_DATE)
  )
}
